<div #nationchartContainer class="w-full h-full relative chart-container-class"></div>
